import React from "react";
import { Center, Text, VStack } from "@commonsku/design-system";
import { SkubotSpinner } from "@commonsku/styles";
import { WorkflowAutomationId, WorkflowAutomationListItem } from "../../../types";
import AutomationListItem from "./AutomationListItem";

export interface AutomationListProps {
  workflows: WorkflowAutomationListItem[];
  loading: boolean;
  togglingWorkflowId: WorkflowAutomationId | null;
  onToggleActive: (workflowId: WorkflowAutomationId, active: boolean) => void;
}

const AutomationList = ({
  workflows,
  loading,
  togglingWorkflowId,
  onToggleActive,
}: AutomationListProps) => {
  if (loading) {
    return (
      <Center paddingY="12">
        <SkubotSpinner />
      </Center>
    );
  }

  if (workflows.length === 0) {
    return (
      <Center paddingY="12">
        <Text color="fg.muted" margin="0!">
          You don&apos;t have any automations yet.
        </Text>
      </Center>
    );
  }

  return (
    <VStack gap="4" align="stretch" width="full">
      {workflows.map((workflow) => (
        <AutomationListItem
          key={workflow.workflow_id}
          workflow={workflow}
          toggling={togglingWorkflowId === workflow.workflow_id}
          onToggleActive={onToggleActive}
        />
      ))}
    </VStack>
  );
};

export default AutomationList;
